<template>
  <div style="padding:10px">
    <van-popup v-model="show" position="bottom"
      :style="{ height: '70%', margin: '10px auto auto auto', padding: '10px' }">
      <van-cascader v-model="newStok" :options="options" @close="show = false" @change="onChange" @finish="onFinish" />
    </van-popup>
    <van-notice-bar wrapable color="#424242" background="#f2f2f2" @click="show = true" style="padding:10px 5px; font-size:21px; border-radius:5px"> {{ fieldValue }} </van-notice-bar>

    <van-cell-group v-if="fieldValue">
      <van-field
        v-if="ymshow"
        v-model="ymmiktar"
        error
        required
        label="kg/m³"
        placeholder="Ysg Miktarı"
        @blur="ymmiktars"
        type="number"
      />

      <van-grid column-num="3" gutter="1" v-if="cocopeatshow" style="margin-top: 15px;">
        <van-grid-item>
          <span style="font-size:18px; background:#f2f2f2; padding:10px 15px">En</span>
          <van-field
            v-model="cocopeaten"
            error
            required
            @blur="cocopeats ()"
            type="number"
          />          
        </van-grid-item>
        <van-grid-item>
          <span style="font-size:18px; background:#f2f2f2; padding:10px 15px">Boy</span>

          <van-field
            v-model="cocopeatboy"
            error
            required
            @blur="cocopeats ()"
            type="number"
          />          
        </van-grid-item>
        <van-grid-item>
          <span style="font-size:18px; background:#f2f2f2; padding:10px 15px">Yükseklik</span>

          <van-field
            v-model="cocopeatyukseklik"
            error
            required
            @blur="cocopeats ()"
            type="number"
            style="padding-left:5px"
          />
        </van-grid-item>

     </van-grid>

     <van-field
        v-if="torfshow"
        v-model="torfmiktar"
        error
        required
        label="kg"
        :placeholder="torfadi+ ' Miktarı'"
        @blur="torfs"
        type="number"
      />
      <van-field
        v-if="plugshow"
        v-model="plug"
        error
        required
        placeholder="İthal Plug Adı"
      />      
      <van-field
        v-if="finish"
        v-model="adet"
        required
        label="Adet"
        placeholder="Satış Adedi"
        type="number"
        style="font-size:26px"

      >
      <template #button>
        <van-button size="small" type="primary">Hesapla</van-button>
      </template>
      </van-field>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newStok:'',
      options: [
        {
          text: 'Paperpot',
          value: 'Paperpot',
          children: [
            { 
              text: 'Kas1', value: 'Kas1' ,
              children:[
                {
                  text: "Ysg yok", value:" ",
                  children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                },
                {
                    text: 'OC2W6', value: 'OC2W6',
                    children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                },
                {
                    text: 'OC2W7', value: 'OC2W7',
                    children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                },
                {
                    text: 'OC2W8', value: 'OC2W8',
                    children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                }, 
              ]
            },
            { 
              text: 'Kas2', value: 'Kas2' ,
              children:[
                {
                  text: "Ysg yok", value:" ",
                  children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                },
                {
                    text: 'OC2W6', value: 'OC2W6',
                    children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                },
                {
                    text: 'OC2W7', value: 'OC2W7',
                    children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                },
                {
                    text: 'OC2W8', value: 'OC2W8',
                    children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                }, 
              ]
            },
            { 
              text: 'Kas3', value: 'Kas3' ,
              children:[
                {
                  text: "Ysg yok", value:" ",
                  children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                },
                {
                    text: 'OC2W6', value: 'OC2W6',
                    children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                },
                {
                    text: 'OC2W7', value: 'OC2W7',
                    children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                },
                {
                    text: 'OC2W8', value: 'OC2W8',
                    children:[
                        {
                          text:'Çap : 30X40', value:'30X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X50', value:'40X50',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        {
                          text:'Çap : 40X40', value:'40X40',
                          children:[
                            {
                              text:'Yükseklik : 100', value:'100',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                            {
                              text:'Yükseklik : 125', value:'125',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },                            
                            {
                              text:'Yükseklik : 150', value:'150',
                              children:[
                                {
                                  text:'Viyollü', value:'Viyollü',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                },
                                {
                                  text:'Viyolsüz', value:'Viyolsüz',
                                  children:[
                                    {text:'Kutulu', value:'Kutulu'},
                                    {text:'Kutusuz', value:'Kutusuz'}
                                  ]
                                }                                
                              ]
                            },
                          ]
                        
                        },
                        ]
                }, 
              ]
            },             
          ],
        },
        {
          text: 'Karışım',
          value: 'Substrat',
          children: [
            { 
              text: 'Kas1', value: 'Kas1' ,
              children:[
                {
                  text: "Ym yok", value:" ",
                  children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W6', value: 'OC2W6',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W7', value: 'OC2W7',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W8', value: 'OC2W8',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                }, 
              ]
            },
            { 
              text: 'Kas2', value: 'Kas2' ,
              children:[
                {
                  text: "Ym yok", value:" ",
                  children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W6', value: 'OC2W6',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W7', value: 'OC2W7',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W8', value: 'OC2W8',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                }, 
              ]
            },    
            { 
              text: 'Kas3', value: 'Kas3' ,
              children:[
                {
                  text: "Ym yok", value:" ",
                  children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W6', value: 'OC2W6',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W7', value: 'OC2W7',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W8', value: 'OC2W8',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                }, 
              ]
            },
            { 
              text: 'Kas4', value: 'Kas4' ,
              children:[
                {
                  text: "Ym yok", value:" ",
                  children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W6', value: 'OC2W6',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W7', value: 'OC2W7',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                },
                {
                    text: 'OC2W8', value: 'OC2W8',
                    children:[
                    {text:'Big Bag 3m3(EN)',value:'Big Bag 3m3(EN)'},
                    {text:'Dökme m3(EN)',value:'Dökme m3(EN)'},
                    {text:'Lt.(EN)',value:'Lt.(EN)'}
                  ]
                }, 
              ]
            },             
          ],
        },
        {
          text:'Cocopeat',
          value:'Cocopeat',
          children:[
            {
            text:'Forteco Elite 0-12 Unwashed (≤ 4.0)', value:'Forteco Elite 0-12 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Elite 0-6 Unwashed (≤ 4.0)', value:'Forteco Elite 0-6 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Elite 1-12 Unwashed (≤ 4.0)', value:'Forteco Elite 1-12 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Elite 0-12 Washed (≤ 0.7)', value:'Forteco Elite 0-12 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Elite 0-6 Washed (≤ 0.7)', value:'Forteco Elite 0-6 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Elite 1-12 Washed (≤ 0.7)', value:'Forteco Elite 1-12 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Power 10 Unwashed (≤ 4.0)', value:'Forteco Power 10 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Power 20 Unwashed (≤ 4.0)', value:'Forteco Power 20 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 30 Unwashed (≤ 4.0)', value:'Forteco Power 30 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 40 Unwashed (≤ 4.0)', value:'Forteco Power 40 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 50 Unwashed (≤ 4.0)', value:'Forteco Power 50 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 60 Unwashed (≤ 4.0)', value:'Forteco Power 60 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 70 Unwashed (≤ 4.0)', value:'Forteco Power 70 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 80 Unwashed (≤ 4.0)', value:'Forteco Power 80 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 90 Unwashed (≤ 4.0)', value:'Forteco Power 90 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 10 Washed (≤ 0.7)', value:'Forteco Power 10 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 20 Washed (≤ 0.7)', value:'Forteco Power 20 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Power 30 Washed (≤ 0.7)', value:'Forteco Power 30 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 40 Washed (≤ 0.7)', value:'Forteco Power 40 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Power 50 Washed (≤ 0.7)', value:'Forteco Power 50 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 60 Washed (≤ 0.7)', value:'Forteco Power 60 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Power 70 Washed (≤ 0.7)', value:'Forteco Power 70 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            }, 
            {
            text:'Forteco Power 80 Washed (≤ 0.7)', value:'Forteco Power 80 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Power 90 Washed (≤ 0.7)', value:'Forteco Power 90 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Profit 0-12 Unwashed (≤ 4.0)', value:'Forteco Profit 0-12 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Profit 0-4 Unwashed (≤ 4.0)', value:'Forteco Profit 0-4 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Profit 8-15 Unwashed (≤ 4.0)', value:'Forteco Profit 8-15 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Profit 0-12 Washed (≤ 0.7)', value:'Forteco Profit 0-12 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Profit 0-4 Washed (≤ 0.7)', value:'Forteco Profit 0-4 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Profit 8-15 Washed (≤ 0.7)', value:'Forteco Profit 8-15 Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Optimum Fine Unwashed (≤ 4.0)', value:'Forteco Optimum Fine Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Optimum Medium Unwashed (≤ 4.0)', value:'Forteco Optimum Medium Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Optimum Coarse Unwashed (≤ 4.0)', value:'Forteco Optimum Coarse Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },

            {
            text:'Forteco Optimum Fine Washed (≤ 0.7)', value:'Forteco Optimum Fine Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Optimum Medium Washed (≤ 0.7)', value:'Forteco Optimum Medium Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Optimum Coarse Washed (≤ 0.7)', value:'Forteco Optimum Coarse Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },

            {
            text:'Forteco Premium Fine Unwashed (≤ 4.0)', value:'Forteco Premium Fine Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Premium Medium Unwashed (≤ 4.0)', value:'Forteco Premium Medium Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Premium Coarse Unwashed (≤ 4.0)', value:'Forteco Premium Coarse Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },

            {
            text:'Forteco Premium Fine Washed (≤ 0.7)', value:'Forteco Premium Fine Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Premium Medium Washed (≤ 0.7)', value:'Forteco Premium Medium Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Premium Coarse Washed (≤ 0.7)', value:'Forteco Premium Coarse Washed (≤ 0.7)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },                                          
            {
            text:'Forteco Maximum 4-12 Buffered (≤ 4.0)', value:'Forteco Maximum 4-12 Buffered (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Maximum 4-12 Unwashed (≤ 4.0)', value:'Forteco Maximum 4-12 Unwashed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },
            {
            text:'Forteco Maximum 4-12 Washed (≤ 4.0)', value:'Forteco Maximum 4-12 Washed (≤ 4.0)',
              children:[
                {text:'Growbag',value:'Growbag'},
                {text:'Growpot',value:'Growpot'},
                {text:'Blok',value:'Blok'},
              ]
            },              

          ]
        },
        {
          text:'Propagation Cubes',value:'Propagation Cubes',children:[
            {text:"7x7x7",value:"7x7x7"},
            {text:"10x10x7",value:"10x10x7"},
            {text:"15x10x7",value:"15x10x7"},
            {text:"20x10x7",value:"20x10x7"}

          ]
        },
        {
          text:'Torf',value:'',children:[
            {
              text:"Beyaz Torf",value:"Beyaz Torf", 
              children:[
              {
                text:"Bigbale",value:"Bigbale",children:[
                  {
                    text:'0-7mm',value:'0-7mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'0-20mm',value:'0-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'0-40mm',value:'0-40mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'3-5mm',value:'3-5mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'5-20mm',value:'5-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'10-20mm',value:'10-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'10-30mm',value:'10-30mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'10-40mm',value:'10-40mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  }                      
                ]
              },
              {
                text:"225",value:"225",children:[
                  {
                    text:'0-7mm',value:'0-7mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'0-20mm',value:'0-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'0-40mm',value:'0-40mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'3-5mm',value:'3-5mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'5-20mm',value:'5-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'10-20mm',value:'10-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'10-30mm',value:'10-30mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'10-40mm',value:'10-40mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  }                      
                ]
              },
              {
                text:"250",value:"250",children:[
                  {
                    text:'0-7mm',value:'0-7mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'0-20mm',value:'0-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'0-40mm',value:'0-40mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'3-5mm',value:'3-5mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'5-20mm',value:'5-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'10-20mm',value:'10-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'10-30mm',value:'10-30mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'10-40mm',value:'10-40mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  }                      
                ]
              },
              ]
            },
            {
              text:"Siyah Torf",value:"Siyah Torf", 
              children:[
              {
                text:"Bigbale",value:"Bigbale",children:[
                  {
                    text:'0-10mm',value:'0-10mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'0-20mm',value:'0-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                    
                ]
              },
              {
                text:"225",value:"225",children:[
                  {
                    text:'0-10mm',value:'0-10mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'0-20mm',value:'0-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },                    
                ]
              },
              {
                text:"250",value:"250",children:[
                  {
                    text:'0-10mm',value:'0-10mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },
                  {
                    text:'0-20mm',value:'0-20mm',
                    children:[
                      {
                        text:"Substrat",value:"Substrat",
                        children:[
                          {text:"Dolokal",value:"Dolokal"},
                          {text:"Fibazorb",value:"Fibazorb"},
                          {text:"Npk",value:"Npk"},
                        ]
                      },
                      {text:"Natural",value:"Natural",}
                    ]
                  },                     
                ]
              },
              ]
            },
          ]
        },
        {
          text:"İthal Plug",value:'İthal Plug',
        }
      ],
      show:false,
      fieldValue: 'Modül Seçiniz',
      ymshow :false,
      ymmiktar:"",
      cocopeatshow :false,
      cocopeaten:0,
      cocopeatboy:0,
      cocopeatyukseklik:0,
      torfshow:false,
      torfmiktar:"",
      torfadi:'',
      plugshow:false,
      plug:'',
      sabit:'', //saçmalk :)
      adet:'',
      finish:false,
    };
  },
  created (){
    this.$store.commit("setLoading",[false,'...']);
  },
  methods: {
    onChange({ value }) {
      //if (value === this.options[0].value) {
      setTimeout(() => {
        this.options[value].children = this.option[value].children;
      }, 500);
      //}
    },
    onFinish({ selectedOptions }) {
      this.ymshow = false;
      this.cocopeatshow = false;
      this.torfshow=false;
      this.plugshow=false;
      if (selectedOptions[0].value == 'Paperpot' || selectedOptions[0].value == 'Substrat') {
        if (selectedOptions[2].value != ' ') {
          selectedOptions.splice(3, 0, {text:'0M3', value:'0M3'});
          selectedOptions.join();
          this.ymshow = true
        }
      }
      if (selectedOptions[0].value == 'Cocopeat') {
        if (selectedOptions[2].value != 'Blok') {
          this.cocopeatshow = true
        }
      }
      if (selectedOptions[0].value == 'Torf') {
        if (selectedOptions[4].value != 'Natural') {
          this.torfadi = selectedOptions[5].value;
          this.torfshow = true
        }
      }
      if (selectedOptions[0].value == 'İthal Plug') {
        this.plugshow = true
      }       
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.value).join(' ');
      this.finish = true
      this.sabit = selectedOptions.map((option) => option.value).join(' ');

    },
    ymmiktars(){
      let field = this.fieldValue.split(' ')
      let deger = field[3]
      this.fieldValue = this.fieldValue.replace(deger, this.ymmiktar+'M3')
    },
    cocopeats(){
      let field2 = ""
      field2=this.cocopeaten+'x'+this.cocopeatboy+'x'+this.cocopeatyukseklik;
      this.fieldValue = this.sabit+' '+field2
    },
    torfs(){
      this.fieldValue = this.sabit+' '+this.torfmiktar+'kg'
    },
    plugs(){
      this.fieldValue = this.sabit+' '+this.plug
    }    
  },
};
</script>
<style>
.van-cell .van-field{
  background-color:#E5E9EC !important;
  height: 35px !important;
  font-size:30px !important
  
}
.van-icon-passed{
  margin-top: 80px;
  color: rgb(104, 211, 104) !important;
  text-align:center !important;
  display: block !important;
}
.van-icon-close{
  margin-top: 80px;
  color: rgb(175, 36, 32) !important;
  text-align:center !important;
  display: block !important;
}

.van-cascader__close-icon {
  color: #484848;
  font-size: 22px;
}
.van-cell__right-icon,.van-icon-down{
  color:#484848 !important;
  font-size:17px !important;
}
.van-cascader__option {
  padding: 5px 16px;
  font-size: 16px !important;
  line-height: 25px !important;
  background: #f2f2f2;
  margin: 10px 0
}

.van-field__control {
  font-size: 15px;
  margin-left:15px
}
.van-cascader__selected-icon{
  color:#002375 !important
}
</style>



// WEBPACK FOOTER //
// src/views/uretim.vue